import { render } from "./EmpSectorsPage.vue?vue&type=template&id=47bbbf7e&scoped=true"
import script from "./EmpSectorsPage.vue?vue&type=script&lang=js"
export * from "./EmpSectorsPage.vue?vue&type=script&lang=js"

import "./EmpSectorsPage.vue?vue&type=style&index=0&id=47bbbf7e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47bbbf7e"]])

export default __exports__